<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>{{ header }} Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-data-table
              :headers="headers"
              :items="items"
              :loading="loading"
              :custom-filter="customSearch"
              :no-data-text="noDataText"
              item-key="key"
              show-select
              v-bind:search="search"
              v-model="selected"
              @input="enterSelect"
              @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <div v-if="checkedItems.length === 0" class="small font-weight-light grey--text">Note: Default is "All" if no item is selected. </div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class="mb-2" @click="doSelect('All', header)">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class="mb-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn>
              <v-btn color="primary" dark class="mb-2" @click="doSelect('', header)">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { helpListMixin } from '@/mixins/common/helpListMixin'

export default {
  props: {
    'apiURI': String,
    'mode': String,
    'param': String
  },
  data() {
    return {
      headers: [
        { text: '', value: 'id' },
        { text: 'Branch', value: 'id' },
        { text: 'Description', value: 'desc' }
      ],
      header: '',
      selected: [],
      parameter: [],
      items: [],
      paramItems: []
    }
  },
  watch: {
    'mode': function (value) {
      this.doInit()
      this.getLabel()
    }
  },
  created() {
    this.doInit()
    this.getLabel()
  },
  methods: {
    doInit() {
      this.parameter = this.param.split(',')
      const apiURI = this.apiURI
      if (apiURI) {
        if (this.parameter !== this.checkedItems) {
          // CBO: to reset the 'this.checkedItems' if called from different mode
          this.doReset()
          this.checkedItems = this.parameter
        }
        this.loading = true
        this.$http.get(apiURI).then(result => {
          this.items = []
          this.selectedItems = []
          const { data } = result.data
          if (data) {
            data.map(param => {
              const convertList = {
                key: param.value,
                id: param.value,
                desc: param.label
              }
              if (this.checkedItems.includes(param.value)) {
                const branchList = {
                  key: param.value,
                  id: param.value,
                  desc: param.label
                }
                this.selectedItems.push(branchList)
              }
              this.items.push(convertList)
            })
          }
          if (this.checkedItems.toString() === 'All') {
            this.doReset()
            this.toggleAll()
          } else {
            this.toggleSelected()
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    },
    getLabel() {
      this.headers = []
      // Add an empty for the checkbox
      this.headers.push({ text: '', value: 'id' })
      switch (this.mode) {
        case 'branch': this.headers.push({ text: 'Branch', value: 'id' })
          this.header = 'Branch'
          break
        case 'fund': this.headers.push({ text: 'Fund', value: 'id' })
          this.header = 'Fund'
          break
        case 'riCo': this.headers.push({ text: 'RI Company', value: 'id' })
          this.header = 'RI Company'
          break
        case 'suffix': this.headers.push({ text: 'Suffix', value: 'id' })
          this.header = 'Suffix'
          break
      }
      this.headers.push({ text: 'Description', value: 'desc' })
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin,
    helpListMixin
  ]
}
</script>
